import { MeasurementPrefUtility, MeterUnitUtility } from '../helpers/MeasurementPref';

/** Seconds per the user's big unit (km or mi) from seconds per metre. */
export function secondsPerBigUnit(secondsPerMeter: number, pref: MeasurementPrefUtility): number {
  return secondsPerMeter * pref.metresFromBigUnit(1);
}

/** "12:30" from seconds. */
export function minutesSeconds(totalSeconds: number): string {
  const total = Math.round(totalSeconds);
  return `${Math.floor(total / 60)}:${String(total % 60).padStart(2, '0')}`;
}

/** "12:30" per the user's big unit. */
export function paceValue(secondsPerMeter: number, pref: MeasurementPrefUtility): string {
  return minutesSeconds(secondsPerBigUnit(secondsPerMeter, pref));
}

export function paceUnit(pref: MeasurementPrefUtility): string {
  return `/${pref.kilometerSymbol()}`;
}

/** "1:03:00" from an hour, otherwise "13:59". */
export function durationLabel(seconds: number): string {
  const total = Math.round(seconds);
  const hours = Math.floor(total / 3600);
  const pad = (n: number) => String(n).padStart(2, '0');
  const minutes = pad(Math.floor((total % 3600) / 60));
  return hours > 0 ? `${hours}:${minutes}:${pad(total % 60)}` : `${minutes}:${pad(total % 60)}`;
}

export function wholeNumber(value: number, locale?: string): string {
  return Math.round(value).toLocaleString(locale);
}

export function toSmallUnit(meters: number, pref: MeasurementPrefUtility): number {
  return meters * MeterUnitUtility.meterToUnitMultiplier(pref.meter());
}

/** Metres in the user's small unit, whole. */
export function smallUnitValue(meters: number, pref: MeasurementPrefUtility, locale?: string): string {
  return wholeNumber(toSmallUnit(meters, pref), locale);
}

/** "0.72": a stride in the user's small unit, to two decimals. */
export function strideValue(meters: number, pref: MeasurementPrefUtility, locale?: string): string {
  return toSmallUnit(meters, pref).toLocaleString(locale, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}

/** Whole hours and the minutes after them, the seconds dropped: 4:12:30 is 4 h 12 min. */
export function hoursAndMinutes(seconds: number): { hours: number; minutes: number } {
  const total = Math.floor(Math.max(seconds, 0) / 60);
  return { hours: Math.floor(total / 60), minutes: total % 60 };
}

/** "12%" but "504 m". */
export function withUnit(value: string, unit: string): string {
  return unit === '%' ? `${value}${unit}` : `${value} ${unit}`;
}

/** Metres an hour in the user's small unit an hour. */
export function verticalSpeedValue(metersPerHour: number, pref: MeasurementPrefUtility, locale?: string): string {
  return smallUnitValue(metersPerHour, pref, locale);
}

export function verticalSpeedUnit(pref: MeasurementPrefUtility): string {
  return `${pref.meterSymbol()}/h`;
}
